import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useRolesRetrieval } from "@planzone/view-models";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection({
  selectedRole,
  placeholder,
  isDisabled,
  select,
}: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();

  return isDisabled ? (
    <div className={classNames(styles.input, styles.disabled)}>
      {selectedRole ? (
        <p className={styles.selection}>
          {t(`roles.${selectedRole.name}`, selectedRole.name)}
        </p>
      ) : (
        <p className={classNames(styles.selection, styles.placeholder)}>
          {placeholder}
        </p>
      )}
    </div>
  ) : (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.roleSelection, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {selectedRole ? (
              <p className={styles.selection}>
                {t(`roles.${selectedRole.name}`, selectedRole.name)}
              </p>
            ) : (
              <p className={classNames(styles.selection, styles.placeholder)}>
                {placeholder}
              </p>
            )}
            <div className={styles.iconBox}>
              <ArrowIcon className={styles.icon} />
            </div>
          </div>
          {isVisible && (
            <div className={styles.list}>
              {roles
                .filter(({ name }) => name.slice(0, "pr_".length) === "pr_")
                .map((role) => (
                  <div
                    key={role.uuid}
                    className={styles.role}
                    onClick={() => {
                      select(
                        selectedRole && selectedRole.uuid === role.uuid
                          ? undefined
                          : role,
                      );
                      hide();
                    }}
                  >
                    {t(`roles.${role.name}`, role.name)}
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { RoleSelection };
